<template>
  <!-- 回显参数 -->
	<div class="image-upload-multiple" style="padding-top: 10px;">
		<el-upload
			ref="uploader"
			:auto-upload="autoUpload"
			:disabled="disabled"
			:action="action"
			:name="name"
			:data="data"
			:http-request="request"
      :file-list="defaultFileList"
			:show-file-list="false"
			:accept="accept"
			:multiple="false"
			:before-upload="before"
      :on-remove="remove"
			:on-success="success"
			:on-error="error"
			:on-preview="handlePreview"
			:on-exceed="handleExceed"
		>
			<slot>
        <div class="image-upload-list-item" v-if="defaultFileList.length > 0">
          <el-image
            v-if="disabled"
            slot="reference"
            class="el-upload-list__item-thumbnail upload-image-size"
            :src="defaultFileList[0].url"
            fit="cover"
            :preview-src-list="preview"
            :initial-index="preview.findIndex((n) => n == defaultFileList[0].url)"
            hide-on-click-modal
            append-to-body
            :z-index="9999"
          >
            <template #placeholder>
              <div class="image-upload-multiple-image-slot">
                Loading...
              </div>
            </template>
          </el-image>
          <el-image v-else :src="defaultFileList[0].url" class="upload-image-size" fit="cover" ></el-image>
          <!-- <el-popover
            v-if="disabled"
            placement="right"
            width="400"
            trigger="hover">
              <el-image
                style="width: 400px;"
                :src="defaultFileList[0].url"
                fit="cover"
              >
              </el-image>
              <el-image
                slot="reference"
                class="el-upload-list__item-thumbnail upload-image-size"
                :src="defaultFileList[0].url"
                fit="cover"
                :preview-src-list="preview"
                :initial-index="preview.findIndex((n) => n == defaultFileList[0].url)"
                hide-on-click-modal
                append-to-body
                :z-index="9999"
              >
                <template #placeholder>
                  <div class="image-upload-multiple-image-slot">
                    Loading...
                  </div>
                </template>
              </el-image>
            </el-popover>
          <el-popover
            v-else
            placement="right"
            width="400"
            trigger="hover">
              <el-image  :src="defaultFileList[0].url" style="width: 400px;" fit="cover" ></el-image>
              <el-image  slot="reference" :src="defaultFileList[0].url" class="upload-image-size" fit="cover" ></el-image>
          </el-popover> -->
					<div
						v-if="!disabled "
						class="image-upload__item-actions"
					>
            <span class="del" @click.stop="handleRemove()">
              <i class="el-icon-delete"></i>
            </span>
          </div>
				</div>
        <div v-else class="el-upload--picture-card ">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </div>
			</slot>
			<template #tip>
				<div v-if="tip" class="el-upload__tip">{{ tip }}</div>
			</template>
		</el-upload>
		<span style="display: none !important"
			><el-input v-model="value"></el-input
		></span>
	</div>
</template>

<script>
import config from './config'
import Sortable from 'sortablejs'
// import cecUnmFileService from '@/api/unmfile/cecUnmFileService'
export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    otherPrams: { type: Object, default: () => {} },
    tip: { type: String, default: '' },
    action: { type: String, default: '' },
    apiObj: { type: Object, default: () => {} },
    name: { type: String, default: config.filename },
    data: { type: Object, default: () => {} },
    accept: { type: String, default: 'image/gif, image/jpeg, image/png' },
    maxSize: { type: Number, default: config.maxSize },
    limit: { type: Number, default: 0 },
    autoUpload: { type: Boolean, default: true },
    showFileList: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    ifSetUploadName: { type: Boolean, default: false },
    updateParams: {
      type: Object,
      default: () => {
        return {
          fileName: '',
          tip: '',
          code: ''
        }
      }
    },
    disabled: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
    onSuccess: {
      type: Function,
      default: () => {
        return true
      }
    }
  },
  data () {
    return {
      value: '',
      defaultFileList: [],
      sortTableRef: null
    }
  },
  // 超级牛
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  watch: {
    modelValue (val) {
      // if (val !== this.toStr(this.defaultFileList)) {
      this.defaultFileList = this.toArr(val)
      this.value = val
      // }
    },
    defaultFileList: {
      handler (val) {
        // this.$emit('change', val)
        this.$emit('changeLisy', val)
        this.value = this.toStr(val)
      },
      deep: true
    },
    disabled: {
      handler (val) {
        if (val && this.draggable) {
          this.sortTableRef.options.disabled = true
        } else {
          if (this.draggable) {
            this.sortTableRef.options.disabled = false
          }
        }
      }
    }
  },
  computed: {
    preview () {
      return this.defaultFileList.map((v) => v.url)
    }
  },
  mounted () {
    this.value = this.modelValue
    this.defaultFileList = this.toArr(this.modelValue)
    if (this.draggable) {
      this.rowDrop()
    }
  },
  methods: {
// 默认值转换为数组
    toArr (str) {
      var _arr = str.map(item => {
        var urlArr = item.filePath.split('&name=')
        var fileName = urlArr[urlArr.length - 1]
        let ch = {
          id: item.id,
          name: fileName,
          url: process.env.VUE_APP_SERVER_URL + item.filePath
        }
        return ch
      })
      // var arr = str.split(',')
      // arr.forEach((item) => {
      //   if (item) {
      //     var urlArr = item.split('&name=')
      //     var fileName = urlArr[urlArr.length - 1]
      //     _arr.push({
      //       name: fileName,
      //       url: process.env.VUE_APP_SERVER_URL + item
      //     })
      //   }
      // })
      return _arr
    },
// 数组转换为原始值
    toStr (arr) {
      return arr.map((v) => v.url).join(',')
    },
    toIdStr (arr) {
      return arr.map((v) => v.id).join(',')
    },
// 拖拽
    async rowDrop () {
      const _this = this
      const itemBox = this.$refs.uploader.$el.querySelector('.el-upload-list')
      this.sortTableRef = await Sortable.create(itemBox, {
        handle: '.el-upload-list__item',
        animation: 200,
        ghostClass: 'ghost',
        onEnd ({ newIndex, oldIndex }) {
          const tableData = _this.defaultFileList
          const currRow = tableData.splice(oldIndex, 1)[0]
          tableData.splice(newIndex, 0, currRow)
          _this.$emit('updateChange', (_this.defaultFileList))
        }
      })
    },
    before (file) {
      if (this.ifSetUploadName && !this.updateParams.fileName) {
        this.$message.error(this.updateParams.tip)
        return false
      }
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        this.$message.warning(`选择的文件类型 ${file.type} 非图像类文件`)
        return false
      }
      const maxSize = file.size / 1024 / 1024 < this.maxSize
      if (!maxSize) {
        this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`)
        return false
      }
    },
    success (res, file, fileList) {
      var os = this.onSuccess(res, file)
      if (os !== undefined && os === false) {
        return false
      }
      var response = config.parseData(res)
      let userObj = JSON.parse(localStorage.getItem('user'))
      if (response.src !== undefined) {
        let num = response.src.data.lastIndexOf('name=')
        let subName = response.src.data.substring(num + 5)
        let lastDotIndex = subName.lastIndexOf('.')
        let subNameNoType = subName.substring(0, lastDotIndex)
        file.url = response.src.data
        file.actorName = userObj.name
        file.actorId = userObj.id
        file.fileName = subName
        file.name = subNameNoType
        this.defaultFileList = [file]
        this.$emit('updateChange', (this.defaultFileList))
      }
    },
    remove (file, fileList) {
      this.defaultFileList = fileList
      // cecUnmFileService.delete(file.id).then(({data}) => {
      //   this.$emit('updateChange', (this.defaultFileList))
      // }).catch(() => {
      // })
    },
    error (err) {
      this.$notify.error({
        title: '上传文件未成功',
        message: err
      })
    },
    beforeRemove (uploadFile) {
      return this.$confirm(`是否移除 ${uploadFile.name} ?`, '提示', {
        type: 'warning'
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    handleRemove (file) {
      // this.$refs.uploader.handleRemove(file)
      this.defaultFileList = []
      this.$emit('updateChange', (this.defaultFileList))
    },
    handleExceed () {
      this.$message.warning(`当前设置最多上传 ${this.limit} 个文件，请移除后上传!`)
    },
    handlePreview (uploadFile) {
      window.open(uploadFile.url)
    },
    getFileExtension (fileName) {
      let uploadName = this.updateParams.fileName.replace(/\s+/g, '_')
      let num = this.defaultFileList.length + 1
      // 使用 lastIndexOf 方法找到最后一个点的位置
      let lastDotIndex = fileName.lastIndexOf('.')
      // 如果没有找到点，返回空字符串或适当的默认值
      if (lastDotIndex === -1) return ''
      // 截取从点到字符串末尾的部分作为扩展名
      let extension = fileName.substring(lastDotIndex)
      // 返回扩展名
      return `${uploadName}_${this.updateParams.code}_${num}${extension}`
    },
    async request (param) {
      var apiObj = config.apiObj
      if (this.apiObj) {
        apiObj = this.apiObj
      }
      const data = new FormData()
      if (this.ifSetUploadName) {
        let uploadName = this.getFileExtension(param.file.name)
        var fileNew = new File([param.file], uploadName)
        data.append(param.filename, fileNew)
      } else {
        data.append(param.filename, param.file)
      }
      for (const key in param.data) {
        data.append(key, param.data[key])
      }
      let params = {
        id: this.otherPrams.id,
        type: this.otherPrams.type,
        uploadPath: 'userdir'
      }
      await apiObj.uploadFileUrl(data, params, {onUploadProgress: (e) => {
        const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
        param.onProgress({ percent: complete })
      }
      }).then((res) => {
        param.onSuccess(res)
      }).catch((err) => {
        param.onError(err)
      })
    }
  }
}
</script>

<style scoped>
.el-form-item.is-error .image-upload-multiple:deep(.el-upload--picture-card) {
	border-color: var(--el-color-danger);
}
:deep(.el-upload-list__item) {
	transition: none;
	border-radius: 0;
}
.image-upload-multiple:deep(.el-upload-list__item.el-list-leave-active) {
	position: static !important;
}
.image-upload-multiple:deep(.el-upload--picture-card) {
	border-radius: 0;
}
.image-upload-list-item {
	width: 100%;
	height: 100%;
	position: relative;
}
.image-upload-multiple .el-image {
	display: block;
}
.image-upload-multiple .el-image:deep(img) {
	-webkit-user-drag: none;
}
.image-upload-multiple-image-slot {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	font-size: 12px;
}
.image-upload-multiple .image-upload-list-item:hover .image-upload__item-actions {
	display: block;
}
.image-upload__item-actions {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}
.image-upload__item-actions span {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 25px;
	height: 25px;
	cursor: pointer;
	color: #fff;
}
.image-upload__item-actions span i {
	font-size: 12px;
}
.image-upload__item-actions .del {
	background: #f56c6c;
}
.image-upload__item-progress {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: var(--el-overlay-color-lighter);
}
.upload-image-size{
  width: 150px;
  height: 150px;
}
</style>
